import { TUser } from '~/features/user/models'
import { EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import pathBuilder from '~/utils/api'

export const queryKeys = {
  users: (filters: Record<string, string | boolean | number> = {}) => [
    EServerPath.users,
    filters,
  ],
  usersInvite: () => [EServerPath.usersInvite],
  user: (userId: string) => [EServerPath.users, userId],
  userCognito: (cognitoUid: string) => [
    EServerPath.users,
    'cognito',
    cognitoUid,
  ],
}

export const queries = {
  userCognito: (cognitoUid: string = '') => ({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeys.userCognito(cognitoUid),
    enabled: !!cognitoUid,
    queryFn: () =>
      HttpService.get<TUser>({
        path: pathBuilder(EServerPath.userCognito, {
          cognitoUid,
        }),
      }),
  }),
}
